// Import PDFJS
window.pdfjsDistBuildPdf = require('pdfjs-dist');

// Load in our PDFJS Worker, convert it to URL, assign to PDFJS obj
// Pulled from https://github.com/mozilla/pdf.js/issues/7612 @wojtekmaj
const pdfjsWorker = require('pdfjs-dist/build/pdf.worker.min');

const pdfjsWorkerBlob = new Blob([pdfjsWorker]);
const pdfjsWorkerBlobURL = URL.createObjectURL(pdfjsWorkerBlob);
window.pdfjsDistBuildPdf.PDFJS.workerSrc = pdfjsWorkerBlobURL;

window.PDFPreview = function PDFPreview(url) {
// Set the URL, and targetCanvas
  this.url = url;
};

window.PDFPreview.prototype.renderPage = function renderPage(page, scale, canvasContainer) {
  const viewport = page.getViewport(scale);
  let canvas;

  if (canvasContainer) {
    canvas = document.createElement('canvas');
  } else {
    canvas = document.getElementById('previewCanvas');
  }

  // Prepare canvas using PDF page dimensions
  canvas.height = viewport.height;
  canvas.width = viewport.width;

  const context = canvas.getContext('2d');

  // Render PDF page into canvas context
  const renderContext = {
    canvasContext: context,
    viewport,
  };

  if (canvasContainer) {
    canvasContainer.appendChild(canvas);
  }

  page.render(renderContext);
};


window.PDFPreview.prototype.loadPDF = function loadPDF(scale, canvasContainer) {
  // Reduce scaling on medium screen sizes
  let renderScale = scale;
  const bootstrapLgWidth = 1200;
  if (canvasContainer.id === 'canvas' && window.innerWidth < bootstrapLgWidth) {
    renderScale = 1.0;
  }

  // Asynchronous download PDF
  window.PDFJS.getDocument(this.url).then((pdf) => {
    const pdfPages = pdf.numPages;
    for (let pageNumber = 1; pageNumber <= pdfPages; pageNumber += 1) {
      // Fetch the  page and render it
      pdf.getPage(pageNumber).then((page) => {
        window.PDFPreview.prototype.renderPage(page, renderScale, canvasContainer);
      });
    }
  });
};


window.PDFPreview.prototype.loadPage = function loadPage(pageNumber, scale) {
  const loadPageNumber = pageNumber || 1;
  const renderScale = scale || 1;
  // Asynchronous download PDF
  window.PDFJS.getDocument(this.url).then((pdf) => {
    // Fetch the  page and render it
    pdf.getPage(loadPageNumber).then((page) => {
      window.PDFPreview.prototype.renderPage(page, renderScale);
    });
  });
};



// WEBPACK FOOTER //
// ./src-assets/js/pdf-preview.js